const WA_LINK = "https://wa.me/50766132697?text=Hola%2C%20quiero%20agendar%20una%20cita%20con%20el%20Dr.%20Erick%20Tejada";

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-28 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/d3d8c53690a9729d17e184af2cf4bc76.jpg"
          alt="Clínica Dr. Erick Tejada Ciudad de Panamá"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-teal-900/55" />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-5 md:px-8 text-center">
        <span
          className="inline-flex items-center gap-2 text-teal-300 text-xs md:text-sm font-medium mb-5"
          style={{ fontFamily: "'Poppins', sans-serif" }}
        >
          <i className="ri-heart-line"></i>
          Prevención a tiempo puede salvar vidas
        </span>

        <h2
          className="text-2xl sm:text-3xl md:text-5xl font-bold text-white mb-5 leading-tight"
          style={{ fontFamily: "'Poppins', sans-serif" }}
        >
          Tu salud es nuestra{" "}
          <span className="italic font-normal" style={{ fontFamily: "'Lora', serif" }}>
            prioridad
          </span>
        </h2>

        <p
          className="text-white/75 text-sm md:text-lg mb-8 md:mb-10 max-w-xl mx-auto leading-relaxed"
          style={{ fontFamily: "'Poppins', sans-serif" }}
        >
          No esperes síntomas para cuidar tu salud femenina. Agenda tu chequeo hoy con el Dr. Erick Tejada, especialista en colposcopia y detección del VPH en Ciudad de Panamá.
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-3 md:gap-4 mb-8 md:mb-10">
          <a
            href={WA_LINK}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="flex items-center justify-center gap-3 bg-green-500 hover:bg-green-600 text-white font-semibold px-7 py-4 rounded-full transition-all text-sm md:text-base whitespace-nowrap cursor-pointer w-full sm:w-auto"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            <i className="ri-whatsapp-line text-lg md:text-xl"></i>
            Agendar Cita por WhatsApp
          </a>
          <a
            href="tel:+50766132697"
            className="flex items-center justify-center gap-3 bg-white/15 hover:bg-white/25 border border-white/40 text-white font-semibold px-7 py-4 rounded-full transition-all text-sm md:text-base whitespace-nowrap cursor-pointer w-full sm:w-auto"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            <i className="ri-phone-line text-lg md:text-xl"></i>
            +507 6613-2697
          </a>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6">
          {[
            { icon: "ri-time-line", text: "Lun–Vie: 9AM–5PM" },
            { icon: "ri-map-pin-line", text: "Ciudad de Panamá" },
            { icon: "ri-calendar-check-line", text: "Con cita previa" },
            { icon: "ri-money-dollar-circle-line", text: "Efectivo / Yappy" },
          ].map((item) => (
            <div
              key={item.text}
              className="flex items-center gap-2 text-white/70 text-xs md:text-sm"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              <i className={`${item.icon} text-teal-300`}></i>
              {item.text}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
